var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-p-3 tw-mt-2",attrs:{"theme":"danger"}},[_vm._v(" It is not possible to request leave which crosses the boundary of the leave allowance year. Please raise separate requests for this year and next year. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }